import { render, staticRenderFns } from "./PuzzleHintList.vue?vue&type=template&id=206a59ee"
import script from "./PuzzleHintList.vue?vue&type=script&lang=js"
export * from "./PuzzleHintList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports